module.exports = __webpack_public_path__ + "fonts/creditu-icons.5fc74b15.eot";